export type EtsyProductSummary = {
  id: string
  title: string
  price: number
  currency: string
  url: string
  state: string
  quantity: number
  tags: string[]
  materials: string[]
  categoryPath: string[]
  images?: Array<{ url_fullxfull?: string; url_570xN?: string; url_170x135?: string }>
  imageUrl?: string
}

export type EtsyProductsResponse = {
  listings: EtsyProductSummary[]
  shopId?: number | string
  shopName?: string
  currentPage: number
  lastPage: number
  total: number
  perPage: number
}

export type EtsyProductDetailResponse = {
  listing: EtsyProductSummary & { description?: string }
  shopId?: number | string
  shopName?: string
}

function etsyErrorMessage(data: unknown, fallback: string): string {
  if (data && typeof data === 'object' && 'message' in data && typeof (data as { message: unknown }).message === 'string') {
    return (data as { message: string }).message
  }
  return fallback
}

export async function getEtsyProducts(
  brandId: string,
  shopId: string,
  page = 1,
  limit = 25,
): Promise<EtsyProductsResponse> {
  const q = new URLSearchParams({
    brandId,
    shopId,
    page: String(page),
    limit: String(limit),
  })
  const res = await fetch(`/api/etsy/listings?${q.toString()}`)
  const data = await res.json()
  if (!res.ok || data?.error) throw new Error(etsyErrorMessage(data, `HTTP ${res.status}`))
  return {
    listings: Array.isArray(data?.listings) ? data.listings : [],
    shopId: data?.shopId,
    shopName: data?.shopName,
    currentPage: data?.currentPage ?? page,
    lastPage: data?.lastPage ?? 1,
    total: data?.total ?? (Array.isArray(data?.listings) ? data.listings.length : 0),
    perPage: data?.perPage ?? limit,
  }
}

export async function getEtsyProduct(
  brandId: string,
  shopId: string,
  listingId: string,
): Promise<EtsyProductDetailResponse> {
  const q = new URLSearchParams({
    brandId,
    shopId,
    listingId,
  })
  const res = await fetch(`/api/etsy/product?${q.toString()}`)
  const data = await res.json()
  if (!res.ok || data?.error) throw new Error(etsyErrorMessage(data, `HTTP ${res.status}`))
  return data as EtsyProductDetailResponse
}

export function pickEtsyListingThumbnail(listing: EtsyProductSummary): string | undefined {
  if (listing.imageUrl) return listing.imageUrl
  const img = listing.images?.[0]
  if (!img) return undefined
  return img.url_170x135 || img.url_570xN || img.url_fullxfull
}
